module.exports = __webpack_public_path__ + "img/type_32-b-150_2.prt.9c7ab707.jpg";